import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_ORDER: MijnRoute = {
    path: ':id/order',
    navigationEvent: 'toOrder',
    regex: /^\/beleggen\/[^/]+\/order$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/order'
};
